module.exports = __webpack_public_path__ + "static/media/burger-menu.28893010.svg";